import {sendJsonToApi} from './apiHelper';

const asFieldList = async (endpoint) => {
    const response = await sendJsonToApi('post', endpoint, {});
    const data = response?.data && typeof response.data === 'object' ? response.data : {};

    return Object.entries(data).map(([key, value]) => ({key, value}));
};

export const fetchPartnerRevenueFields = () => asFieldList('/api/partner-revenue/revenues/fields');
export const fetchPartnerConnectionFields = () => asFieldList('/api/partner-revenue/connections/fields');
export const fetchPartnerCompanies = () => asFieldList('/api/partner-revenue/companies');

export const fetchPartners = async () => {
    const response = await sendJsonToApi('post', '/api/partner-revenue/partners', {});
    const list = Array.isArray(response?.data) ? response.data : [];

    return list.map((partner) => ({key: partner.id, value: partner}));
};

export const fetchPartnerConnections = (options = {}) =>
    sendJsonToApi('post', '/api/partner-revenue/connections', options, 'PartnerApiConnections');

export const updatePartnerConnection = (payload, onSuccess) =>
    sendJsonToApi('post', '/api/partner-revenue/connections/update', payload, false, onSuccess);

export const fetchPartnerRevenueReport = (options) =>
    sendJsonToApi('post', '/api/partner-revenue/revenues', options, 'PartnerRevenueReport');
